import axios from "axios";
import moment from "moment";
import React, { useContext, useEffect, useRef, useState } from "react";
import { FileDrop } from "react-file-drop";
import { AiOutlineUpload } from "react-icons/ai";
import swal from "sweetalert";
import { serverInfo } from "../../../../App";
import PendingAuditionCard from "../PendingAuditionCard/PendingAuditionCard";
import "./AuditionDragAndDrop.css";
import useAuditionVideoUpload from "../../../../CustomHooks/useAuditionVideoUpload";
import MediaUploadProgressBar from "../../../../Screen/MediaUploadProgressBar";

const AuditionDragAndDrop = ({ instruction, roundInfo }) => {
  const { imageCdnUrl,videoCdnUrl } = useContext(serverInfo);



  const [error_list, setErrorList] = useState([]);
  const [videoList, setVideoList] = useState([]);
  const [appealvideoList, setAppealVideoList] = useState([]);
  const [videoSlot, setVideoSlot] = useState(0);
  const [appealVideoSlot, setAppealVideoSlot] = useState(0);
  const [loader, setLoader] = useState(false);
  const [buffer, setBuffer] = useState(false);
  const [videoType, setVideoType] = useState("general");
  const [isAppealedForThisRound, setIsAppealedForThisRound] = useState({});
  const [appealedRegistration, setAppealedRegistration] = useState({});
  const [markTracking, setMarkTracking] = useState({});
  let currentTime = new Date().toJSON().slice(0, 10);


  // Convert string to Date objects
  const currentTimeDate = new Date(currentTime).getTime();
  const videoUploadEndDate = new Date(roundInfo.video_upload_end_date).getTime();


  const [videoUrls, videoKeys, videoProgress, setFiles, setDeleteFile, setProgress] = useAuditionVideoUpload();


  const appeal_start_date =
    moment(roundInfo.appeal_start_date).format("LL") + " " + "00:00:00";
  const countDownDate = new Date(appeal_start_date).getTime();


  const fetchUploadedVideo = (audition_id, round_info_id) => {
    axios
      .get(
        `api/user/audition/uploaded_round_videos/${audition_id}/${round_info_id}`
      )
      .then((res) => {
        if (res.data.status === 200) {
          setVideoList(res?.data?.videos);
          setAppealVideoList(res?.data?.appeal_videos);
          setMarkTracking(res?.data?.auditionRoundMarkTracking);
        }
      });
  };

  const checkIsAppealForRound = (audition_id, round_info_id) => {
    setLoader(true);

    axios
      .get(`api/user/audition/is_appeal/round/${audition_id}/${round_info_id}`)
      .then((res) => {
        if (res.data.status === 200) {
          setIsAppealedForThisRound(res.data.isAppealedForThisRound);
          if (res?.data?.isAppealedForThisRound == true) {
            setAppealedRegistration(res.data.appealedRegistration);
          }
          setBuffer(false);
          setLoader(false);
        }
      });
  };

  useEffect(() => {
    fetchUploadedVideo(roundInfo?.audition_id, roundInfo?.id);
    checkIsAppealForRound(roundInfo?.audition_id, roundInfo?.id);
    setVideoSlot(roundInfo?.video_slot_num);
    setAppealVideoSlot(roundInfo?.appeal_video_slot_num);
  }, [roundInfo?.audition_id, roundInfo?.id, roundInfo?.video_slot_num]);

  useEffect(() => {
    setErrorList([]);
    // setShowFile([]);
    fetchUploadedVideo(roundInfo.audition_id, roundInfo.id);
    checkIsAppealForRound(roundInfo.audition_id, roundInfo.id);
  }, [videoType]);

  const fileInputRef = useRef(null);

  const onFileInputChange = async (event) => {
    const file = event.target.files[0];
    console.log( formatBytes(event.target.files[0].size,0))
    const video = await loadVideo(event.target.files[0])
    console.log(video.duration);

    if(formatBytes(event.target.files[0].size,0)>=50){
      swal("Warning", 'Maximum video file size is 50MB,Please compress the video before upload.', "warning");
    }else {
      if(video.duration <=  roundInfo.video_duration){
        setProgress(0)
        setFiles(file)
      }else{
        swal("Warning", 'Can\'t upload videos longer than ' + roundInfo.video_duration + ' seconds', "warning");
      }
    }


  }

  function formatBytes(bytes, decimals = 2) {
    if (!+bytes) return '0 Bytes'

    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ['Bytes', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']

    const i = Math.floor(Math.log(bytes) / Math.log(k))

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm))
  }

  const loadVideo = file => new Promise((resolve, reject) => {
    try {
      let video = document.createElement('video')
      video.preload = 'metadata'

      video.onloadedmetadata = function () {
        resolve(this)
      }

      video.onerror = function () {
        swal("Warning", "Invalid video. Please select a video file.", "warning");
        reject("Invalid video. Please select a video file.")
      }

      video.src = window.URL.createObjectURL(file)
    } catch (e) {
      reject(e)
    }
  })

  const onTargetClick = () => {
    fileInputRef.current.click();
  };

  const uploadVideo = (e) => {
    setBuffer(true);
    e.preventDefault();
    const formData = new FormData();
    formData.append("audition_id", roundInfo.audition_id);
    formData.append("round_info_id", roundInfo.id);
    formData.append("type", videoType);

    if (
      Number(videoType == "general" ? videoSlot : appealVideoSlot)
    ) {
      videoKeys.forEach((image_file) => {
        formData.append("file[]", image_file);
      });
    } else {
      swal(
        "Error",
        "Please Upload " + videoType == "general"
          ? videoSlot
          : appealVideoSlot + " Videos",
        "error"
      );
    }

    axios.post(`api/user/audition/round-video-upload`, formData).then((res) => {
      setBuffer(false);
      if (res.data.status === 200) {
        setErrorList([]);
        swal("Success", res.data.message, "success");
        fetchUploadedVideo(roundInfo.audition_id, roundInfo.id);
      } else if (res.data.status === 422) {
        setErrorList(res.data.validation_errors);
      } else {
      }
    });
  };

  const handleAppealedVideo = () => {
    if (appealedRegistration?.id) {
      setVideoType("appeal");
    }
  };

  const handleGeneralVideo = () => {
    setVideoType("general");
  };

  const authName = localStorage.getItem("auth_name");

  const joinCall = (room_id) => {
    // setCallJoinBuffer(true)
    axios
      .get("/sanctum/csrf-cookie")
      .then((response) => {
        axios
          .get(`api/sdk/get-token/user`)
          .then((res) => {
            // setCallJoinBuffer(false)
            // setToken(res.data.token);

            window.open(
              `/video-meeting?token=${res.data.token}&meetingId=${room_id}&webcamEnabled=true&micEnabled=true&name=${authName}&whiteboardEnabled=true&canDrawOnWhiteboard=false&canToggleWhiteboard=false&screenShareEnabled=false&askJoin=true`
            );
          });
      })
      .catch((err) => {
        // alert('network problem')
      });
  };


  return (
    <div>
      <div className=" card card-bg1 my-3">
        {roundInfo.round_type === 0 ? (
          <>
            <div className="p-3">
              <div className="d-flex justify-content-between">
                <h4 className="text-center text-warning">Video Submission </h4>
              </div>
            </div>

            <div className="d-flex justify-content-around my-3">
              <button
                onClick={handleGeneralVideo}
                className={
                  videoType === "general" ? "btnLinear" : "btnLinearInactive"
                }
              >
                General Videos
              </button>
              {roundInfo?.round_type === 0 && roundInfo?.appeal === 1 ? (
                <>
                  {Number(markTracking?.wining_status) === 1 ? (
                    <></>
                  ) : (
                    <>
                      <button
                        onClick={handleAppealedVideo}
                        className={
                          videoType == "appeal"
                            ? "btnLinear"
                            : "btnLinearInactive"
                        }
                      >
                        Appealed Videos
                      </button>
                    </>
                  )}
                </>
              ) : (
                <></>
              )}
            </div>

            {videoType === "general" ? (
              <>
                <div className="under-line">
                </div>
                <div className="row d-flex justify-content-center mt-3">
                  {videoList.length < 1 && videoKeys.map((data, i) => (
                    <div className="col-md-4 mb-2">
                      <div className="card card-bg1  p-2">
                        <span className="text-danger pointer-link" onClick={() => setDeleteFile(data)}>X</span>
                        <video height="150" key={i} controls>
                          <source
                            src={
                              data != null ? videoCdnUrl + data : null
                            }
                            type="video/mp4"
                          />
                        </video>
                      </div>
                    </div>
                  ))}

                  {videoList.map((data, i) => (
                    <div className="col-md-4 mb-2">
                      <div className="card card-bg1  p-2">
                        <video height="150" key={i} controls>
                          <source
                            src={
                              data.video != null ? videoCdnUrl + data.video : null
                            }
                            type="video/mp4"
                          />
                        </video>
                      </div>
                    </div>
                  ))}

                </div>

                {roundInfo?.round_type === 0 ? (
                  <>
                    {Number(videoList.length) < 1 ? (
                      <>
                        <div className="row d-flex justify-content-center">

                          {videoSlot > videoKeys.length &&

                            <div className="col-md-4 my-2">
                              {currentTimeDate < videoUploadEndDate ? (
                              <div className="CardBorder">
                            
                               
                                <div className="fileUploadCard">
                                  <input
                                    onChange={onFileInputChange}
                                    ref={fileInputRef}
                                    type="file"
                                    className="hidden"
                                    // accept="video/mp4,video/x-m4v,video/*"
                                    accept="video/mp4*"
                                  />

                                  <FileDrop
                                    onDrop={(files, event) =>
                                      setFiles(files[0])
                                    }
                                    onTargetClick={onTargetClick}
                                    targetClassName="target"
                                    className="filedrop"
                                    draggingOverFrameClassName="filedropDrag"
                                  >
                                    <div>
                                      <div className="iconCustomized text-center">
                                        <AiOutlineUpload className="icon" />
                                      </div>
                                      <p className="p-2">
                                        Click or Drag and drop Video File
                                      </p>
                                    </div>
                                  </FileDrop>
                                  
                                  {videoProgress > 0 && videoProgress < 100 ? <div >

                                    <MediaUploadProgressBar progress={videoProgress} />


                                  </div> : null}
                                </div>
                                </div>
                              ): (
                               <></>
                            
                              )}
                            </div>
                          }
                        </div>
                        <span className="text-danger">{error_list.file}</span>

                        <div className="row my-4">
                          {currentTimeDate > videoUploadEndDate ? (
                            <>
                            <h5 style={{ color: "white", textAlign: 'center' }}>Video Upload Time is Over</h5>
                           </>
                            
                          ):( 
                            <center>
                              <button
                                className="btn btn-register  fw-bold  mb-3"
                                onClick={uploadVideo}
                                disabled={videoKeys.length < videoSlot?true:false}
                              >
                                {buffer ? (
                                  <>
                                    <i className="fas fa-spinner fa-pulse"></i>
                                    &nbsp;
                                  </>
                                ) : null}
                                Upload {videoKeys.length + "/" + videoSlot}
                              </button>
                            </center>
                          )}
                        </div>
                      </>
                    ) : (
                      <h4 className="text-warning text-center fw-bold py-3">
                        Your Videos Has Been Uploaded
                      </h4>
                    )}
                  </>
                ) : (
                  <></>
                )}
              </>
            ) : (
              <>
                {countDownDate >= new Date().getTime() ? (
                  <>
                    <h2 className="text-danger text-center">
                      Please wait until round appeal start!!
                    </h2>
                  </>
                ) : (
                  <>
                    <div className="under-line"></div>

                    <div className="row d-flex justify-content-center">
                      {appealvideoList.length < 1 && videoKeys.map((data, i) => (
                        <div className="col-md-4 mb-2">
                          <div className="card card-bg1  p-2">
                            <span className="text-danger pointer-link" onClick={() => setDeleteFile(data)}>X</span>
                            <video height="150" key={i} controls>
                              <source
                                src={
                                  data != null ? videoCdnUrl + data : null
                                }
                                type="video/mp4"
                              />
                            </video>
                          </div>
                        </div>
                      ))}

                      {appealvideoList.map((data, i) => (
                        <>
                          <div className="col-md-4 mb-2">
                            <div className="card card-bg1  p-2">
                              <video height="150" key={i} controls>
                                <source
                                  src={
                                    data.video != null
                                      ? videoCdnUrl + data.video
                                      : null
                                  }
                                  type="video/mp4"
                                />
                              </video>
                            </div>
                          </div>
                        </>
                      ))}
                    </div>

                    {Number(appealvideoList?.length) < 1 ? (
                      <>
                        <div className="row d-flex justify-content-center">
                          {appealVideoSlot > videoKeys.length &&
                            <div className="col-md-4 my-2">
                              <div className="CardBorder">
                                <div className="fileUploadCard">
                                  <input
                                    onChange={onFileInputChange}
                                    ref={fileInputRef}
                                    type="file"
                                    className="hidden"
                                    // accept="video/mp4,video/x-m4v,video/*"
                                    accept="video/mp4"
                                  />

                                  <FileDrop
                                    onDrop={(files, event) =>
                                      setFiles(files[0])
                                    }
                                    onTargetClick={onTargetClick}
                                    targetClassName="target"
                                    className="filedrop"
                                    draggingOverFrameClassName="filedropDrag"
                                  >
                                    <div>
                                      <div className="iconCustomized text-center">
                                        <AiOutlineUpload className="icon" />
                                      </div>
                                      <p className="p-2">
                                        Click or Drag and drop Video File
                                      </p>
                                    </div>
                                  </FileDrop>
                                  {videoProgress > 0 && videoProgress < 100 ? <div >

                                    <MediaUploadProgressBar progress={videoProgress} />
                                  </div> : null}
                                </div>
                              </div>
                            </div>
                          }
                        </div>
                        <span className="text-danger">{error_list.file}</span>

                        <div className="row my-4">
                          <center>
                            <button
                              className="btn btn-register  fw-bold  mb-3"
                              onClick={uploadVideo}
                              disabled={videoKeys.length < appealVideoSlot?true:false}
                            >
                              {buffer ? (
                                <>
                                  <i className="fas fa-spinner fa-pulse"></i>
                                  &nbsp;
                                </>
                              ) : null}
                              Upload {videoKeys.length + "/" + appealVideoSlot}
                            </button>
                          </center>
                        </div>
                      </>
                    ) : (
                      <h3 className="text-warning text-center my-2">
                        Your Appeal Videos Has Been Uploaded
                      </h3>
                    )}
                  </>
                )}
              </>
            )}
          </>
        ) : (
          <div className="row p-4">
            <div className="col-md-4 mx-auto">
              <button
                className="payConfirm btn btn-warning m-auto"
                onClick={() => joinCall(roundInfo?.room_id)}
              >
                Click to Join
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AuditionDragAndDrop;
